import { javaApi } from '../../utils/AxiosInstance';

import styles from '../../styles/policy.module.scss';

function TermsConditions({ data }) {
  return (
    <div className={styles.container}>
      <div>
        {data?.[2]?.htmlContent && (
          <div
            dangerouslySetInnerHTML={{
              __html: data?.[2]?.htmlContent,
            }}
          />
        )}
      </div>
    </div>
  );
}

export async function getServerSideProps() {
  try {
    const { data: { data } } = await javaApi.get('app-content-ws/v1/html/pages/getAllPages');

    return { props: { data } };
  } catch (error) {
    console.log(error);
  }

  return { notFound: true };
}

export default TermsConditions;
